const v3 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        topScriptTopicsTable: {
          ...state.options.tableViews.topScriptTopicsTable,
          Rpm: false,
        },
        topThumbTopicsTable: {
          ...state.options.tableViews.topThumbTopicsTable,
          Rpm: false,
        },
        topTitleTopicsTable: {
          ...state.options.tableViews.topTitleTopicsTable,
          Rpm: false,
        },
        topVideoTypesTable: {
          ...state.options.tableViews.topVideoTypesTable,
          Rpm: false,
        },
      },
    },
  };
};

export default v3;
